import React from 'react';

import { PageTitleVioletS} from '../adminLayout/adminCommonStyles';

import CompanyFieldsScoresComponent from './companyFieldsScoresComponent';

const DashboardComponent = () => (
    <>
        <PageTitleVioletS>Dashboard</PageTitleVioletS>
        <CompanyFieldsScoresComponent />
    </>
);

export default DashboardComponent;
